import { Chip } from '@/components/commons/chip'
import { ErrorBox } from '@/components/commons/error-box'
import { GalleryImageItem } from '@/components/commons/gallery-image-item'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { AlertTriangleIcon, Trash01Icon } from '@/components/ui/icons'
import { OpsVettingGalleryItemsContainer } from '@/features/ops-vetting/components/ops-vetting-atoms'
import { CircularProgressBar } from '@/features/service-vetting/components/circular-progress-bar'
import {
	type GalleryItem,
	useServicePhotoUpload
} from '@/features/service-vetting/store/services-photo-upload.ts'
import { useTranslation } from '@/translations/i18n'

export const ServiceVettingCriteriaUploadingItem = ({
	image
}: {
	image: GalleryItem
}) => {
	const { t } = useTranslation()
	const uploadProgressValues = useServicePhotoUpload(
		(store) => store.uploadProgressValues
	)
	const deleteGalleryItem = useServicePhotoUpload(
		(store) => store.deleteGalleryItem
	)
	const onClickDelete = () => {
		URL.revokeObjectURL(image.url)
		deleteGalleryItem(image.id)
	}

	return (
		<OpsVettingGalleryItemsContainer>
			<GalleryImageItem
				bottomLeftSlot={
					<Chip
						label={t(
							'vetting:criteria.service.gallery.internal_upload'
						)}
						variant={'neutral'}
					/>
				}
				centerSlot={
					image.status === 'pending' ? (
						<CircularProgressBar
							progress={uploadProgressValues[image.id] || 0}
						/>
					) : (
						image.status === 'error' && (
							<ErrorBox
								icon={<AlertTriangleIcon />}
								title={t('errors:default')}
							/>
						)
					)
				}
				hasBlur={image.status !== 'uploaded'}
				src={image.thumbnails?.xs || image.url}
				topRightSlot={
					<ButtonLegacy
						onClick={onClickDelete}
						shape='square'
						type='button'
						variant={'secondary'}
					>
						<Trash01Icon />
					</ButtonLegacy>
				}
			/>
		</OpsVettingGalleryItemsContainer>
	)
}
